import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AnalyticsInitializerService {
  load(): Promise<void> {
    return new Promise((resolve) => {
      const id = (environment as any).gaMeasurementId as string;
      const isProd = (environment as any).production;
      
      if (!id) {
        console.warn('[GA4] No Measurement ID configured - analytics disabled');
        return resolve();
      }

      // Avoid double-injecting
      if (document.getElementById('ga4-gtag')) {
        return resolve();
      }

      // Initialize dataLayer first
      (window as any).dataLayer = (window as any).dataLayer || [];
      function gtag(...args: any[]){ (window as any).dataLayer.push(arguments); }
      (window as any).gtag = gtag;

      // Add gtag JS
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      gtagScript.id = 'ga4-gtag';
      gtagScript.onload = () => {
        
        // Initialize GA4
        (window as any).gtag('js', new Date());
        (window as any).gtag('config', id, {
          anonymize_ip: true,
          send_page_view: true
        });
        resolve();
      };
      gtagScript.onerror = (error) => {
        console.error('[GA4] Failed to load gtag.js:', error);
        resolve();
      };
      document.head.appendChild(gtagScript);
    });
  }
}
